// src/pages/Reports/ItemProfitLoss/itemProfitLossSlice.js
import { createSlice } from "@reduxjs/toolkit";
import { fetchItemProfitLoss } from "./itemProfitLossThunk";
import _ from "lodash";
import dayjs from "dayjs";
import { currentDateEndTime, currentDateStartTime } from "../../../lib/functions";

const today = dayjs();
const initialState = {
  filters: {
    type: "All Item Stock",   // Record type
    filterType: "Date Wise",  // Date filter type
    fromDate: currentDateStartTime(today),
    toDate: currentDateEndTime(today),
    itemId: null,
    groupId: null,
    categoryId: null,
    warehouseId: null,
  },
  data: [],
  totals: {
    totalSold: 0,
    totalCosting: 0,
    totalReplaceSold: 0,
    totalReplaceCosting: 0,
    totalReturnSold: 0,
    totalReturnCosting: 0,
    totalProfit: 0,
  },
  loading: false,
  error: null,
};

const itemProfitLossSlice = createSlice({
  name: "itemProfitLoss",
  initialState,
  reducers: {
    setFilters(state, action) {
      state.filters = { ...state.filters, ...action.payload };
    },
    resetFilters(state) {
      state.filters = initialState.filters;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchItemProfitLoss.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchItemProfitLoss.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload || [];

        // ✅ Compute totals (like old UI with _.sumBy)
state.totals = {
  totalSold: _.sumBy(state.data, (r) => Number(r.sold_amount) || 0),
  totalCosting: _.sumBy(state.data, (r) => Number(r.costing_amount) || 0),
  totalReplaceSold: _.sumBy(state.data, (r) => Number(r.given_replace_amount) || 0),
  totalReplaceCosting: _.sumBy(state.data, (r) => Number(r.given_replace_costing_amount) || 0),
  totalReturnSold: _.sumBy(state.data, (r) => Number(r.return_sold_amount) || 0),      // ✅
  totalReturnCosting: _.sumBy(state.data, (r) => Number(r.return_costing_amount) || 0), // ✅
  totalProfit: _.sumBy(state.data, (r) => Number(r.item_profit) || 0),
};
      })
      .addCase(fetchItemProfitLoss.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Error fetching Item Profit/Loss data";
      });
  },
});

export const { setFilters, resetFilters } = itemProfitLossSlice.actions;
export default itemProfitLossSlice.reducer;
